export default {
      id: "common__line-close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__line-close",
      toString: function () {
        return this.url;
      }
    }